import { useCallback } from 'react';

// eslint-disable-next-line no-restricted-imports
import { useUserUpdateTimezoneMutation } from 'api/generated/graphql';
import { useError } from 'api/helpers';
import { parseUserEntity } from 'api/helpers/parseEntity';

export const useUserUpdateTimezone = () => {
  const [handle, { loading, error: apolloError }] =
    useUserUpdateTimezoneMutation();

  const error = useError(apolloError);

  return {
    loading,
    error,
    updateTimezone: useCallback(
      async (timezoneName?: string) => {
        const input = {
          name: timezoneName || null,
        };

        const res = await handle({ variables: { input } });
        if (res.data?.userUpdateTimezone) {
          return parseUserEntity(res.data?.userUpdateTimezone);
        }

        return undefined;
      },
      [handle]
    ),
  };
};
